import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'extras_checkin_funnel_v2_form';
export const route = 'checkin/form/[token]';
export const CheckinFunnelFormPage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "extras_checkin_funnel_v2_form" */
/* webpackPrefetch: true */
'../../components/CheckInFunnel/FormPage')));